export default {"src":"/_next/static/media/whalesync-logo.d8dcc739.svg","height":70,"width":302};